<template>
    <img v-if="isImgTag" :src="src" :alt="alt">
    <div v-else class="bg-img" :style="imgStyle"></div>
</template>

<script>
import { lazyloadMixins } from '../fego/FEGORender';

const preLoadSource = (src) => {
    const link = document.createElement('link');

    link.rel = 'preload';
    link.href = src;
    link.as = 'image';
    link.crossOrigin = 'anonymous';

    document.getElementsByTagName('head')[0].appendChild(link);
    console.log(`preload ${src}`);
}

export default {
    name: 'Img',
    props: {
        src: { type: String },
        alt: { type: String },
        preload: { type: Boolean },
    },
    mixins: [lazyloadMixins()],
    computed: {
        isImgTag() {
            return this.alt;
        },
        imgStyle() {
            if (!this.src || !this.lazyloadHasReach) return {};
            return {
                backgroundImage: `url(${this.src})`
            };
        }
    },
    created() {
        if (this.preload && this.src) {
            //<link rel="preload" :href="path" as="image"  crossorigin="anonymous">
            preLoadSource(this.src);
        }
    },
};
</script>

<style scoped>
.bg-img {
    transform: rotate3d(0, 0, 1, 0deg);
    background-size: 100% 100%;
}
</style>



// WEBPACK FOOTER //
// src/render/index.vue